import React, { Component } from 'react'
import EducationList from './EducationList.js'
import '../CSS/StudentList.css';
import Sidemenu from './Navbar/Sidemenu';
class EducationHome extends Component
{
    render(){
        return(
            <div>
                <nav className="nav-wrapper grey darken-4 navbar">
                <div className="container">
            <a href="/" className="brand-logo">
                        <img
                            className="header__logo"
                            src="./logo.jpg"
                            alt="logo"
                            />
                            </a>
               <ul className = "right">
                    <li><a href = "/sender">Sender</a></li>
                    <li active><a href = "/recipient">Recipient</a></li>
                    <li><a href = "/newRecord">Request Record</a></li>
                   <li active><a href = "/token">Token</a></li>
                   <li active><a href = "/coin">Coin</a></li>
                   <li active><a href = "/nft">NFT</a></li>
                   <li><a href = "/">Log out</a></li>
               </ul>
            </div>
                </nav>
                
                <div className = "container-fluid bg-black">
                <div className="row">
                    <Sidemenu />
                    <div className="col s10">
                    <h4>List of Record Requests</h4> 
                    <div className="card blue darken-3 headers">
                        <div className="row ">
                            <div className="col s3 white-text  ">
                                <h6>Student ID</h6>
                            </div>
                            <div className="col s3 white-text ">
                                <h6>Record Name</h6>
                            </div>

                            <div className="col s3 white-text ">
                                <h6>Description</h6>
                            </div>
                            <div className="col s3 white-text ">
                                <h6>Created Timestamp</h6>
                            </div>
                        </div>
                    </div>
                    <EducationList/>
                    </div>
                </div>
                </div>
            </div>
        )
    }
}

export default EducationHome;
